import React from 'react';
import { MessageSquareIcon, ClockIcon, UserIcon } from 'lucide-react';
const KeyFeatures = () => {
  return <section id="features" className="py-16 bg-white" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="text-center" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-bold font-display text-charcoal" data-id="element-84">
            Features That Make the Difference
          </h2>
          <p className="mt-4 max-w-2xl text-lg text-sage mx-auto" data-id="element-85">
            Designed specifically for restaurant owners who value authentic
            customer relationships
          </p>
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-8" data-id="element-86">
          <div className="bg-cream rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-87">
            <div className="w-12 h-12 bg-burgundy/10 rounded-full flex items-center justify-center mb-5" data-id="element-88">
              <MessageSquareIcon className="text-burgundy" size={24} data-id="element-89" />
            </div>
            <h3 className="text-xl font-semibold text-charcoal mb-3" data-id="element-90">
              Instant Authentic Responses
            </h3>
            <p className="text-sage" data-id="element-91">
              ChefChat responds to customer inquiries in seconds, using your
              restaurant's unique voice and style. No generic robot responses.
            </p>
            <ul className="mt-4 space-y-2" data-id="element-92">
              <li className="flex items-center text-sm" data-id="element-93">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-94">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-95" />
                </svg>
                Personalized messaging style
              </li>
              <li className="flex items-center text-sm" data-id="element-96">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-97">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-98" />
                </svg>
                Multi-language support
              </li>
              <li className="flex items-center text-sm" data-id="element-99">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-100">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-101" />
                </svg>
                Restaurant-specific terminology
              </li>
            </ul>
          </div>
          <div className="bg-cream rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-102">
            <div className="w-12 h-12 bg-burgundy/10 rounded-full flex items-center justify-center mb-5" data-id="element-103">
              <ClockIcon className="text-burgundy" size={24} data-id="element-104" />
            </div>
            <h3 className="text-xl font-semibold text-charcoal mb-3" data-id="element-105">
              24/7 Customer Service
            </h3>
            <p className="text-sage" data-id="element-106">
              Never miss another reservation or inquiry, even during your
              busiest service hours or in the middle of the night.
            </p>
            <ul className="mt-4 space-y-2" data-id="element-107">
              <li className="flex items-center text-sm" data-id="element-108">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-109">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-110" />
                </svg>
                Always available, never tired
              </li>
              <li className="flex items-center text-sm" data-id="element-111">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-112">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-113" />
                </svg>
                Handles peak hour inquiries
              </li>
              <li className="flex items-center text-sm" data-id="element-114">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-115">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-116" />
                </svg>
                Automatic follow-ups
              </li>
            </ul>
          </div>
          <div className="bg-cream rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-117">
            <div className="w-12 h-12 bg-burgundy/10 rounded-full flex items-center justify-center mb-5" data-id="element-118">
              <UserIcon className="text-burgundy" size={24} data-id="element-119" />
            </div>
            <h3 className="text-xl font-semibold text-charcoal mb-3" data-id="element-120">
              Your Unique Voice Preserved
            </h3>
            <p className="text-sage" data-id="element-121">
              ChefChat learns your communication style and preserves your
              restaurant's unique personality and tone in every interaction.
            </p>
            <ul className="mt-4 space-y-2" data-id="element-122">
              <li className="flex items-center text-sm" data-id="element-123">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-124">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-125" />
                </svg>
                Voice training technology
              </li>
              <li className="flex items-center text-sm" data-id="element-126">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-127">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-128" />
                </svg>
                Customizable responses
              </li>
              <li className="flex items-center text-sm" data-id="element-129">
                <svg className="w-5 h-5 mr-2 text-burgundy" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-130">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-131" />
                </svg>
                Continuous learning
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 bg-burgundy/5 rounded-xl p-8" data-id="element-132">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-133">
            <div className="mb-6 md:mb-0 md:mr-8" data-id="element-134">
              <h3 className="text-2xl font-semibold text-charcoal" data-id="element-135">
                Restaurant-Specific Intelligence
              </h3>
              <p className="mt-2 text-sage max-w-xl" data-id="element-136">
                ChefChat is built specifically for restaurants, understanding
                menu questions, dietary restrictions, and hospitality nuances.
              </p>
            </div>
            <button className="bg-burgundy text-cream hover:bg-burgundy/90 transition-colors px-6 py-3 rounded-md font-medium" data-id="element-137">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>;
};
export default KeyFeatures;